import { gql } from "apollo-angular";
import { BASEMODEL_FRAGMENT } from "./base-definition";
import { FACET_VALUE_FRAGMENT } from "./facet-value.definition";
import { PRODUCT_FRAGMENT } from "./product-definition";
import { DELETION_RESPONSE_FRAGMENT } from "./system-definition";

// NOT IN USE
// export const TRANSLATE_FIELDS_FRAGMENT = gql`
// fragment TranslateFields on Translate {
//     id
//     languageCode
//     name
// }
// `;
// NOT IN USE
// export const PRODUCT_VARIANT_TO_FACET_VALUE_TRANSLATION_FRAGMENT = gql`
// fragment Translation on ProductVariantToFacetValueLinkTranslation {
//     id
//     languageCode
//     name
// }
// `;

export const PRODUCT_VARIANT_TO_FACET_VALUE_FIELDS_FRAGMENT = gql`
fragment ProductVariantToFacetValueLinkFields on ProductVariantToFacetValueLink {
    ...IBaseModel
    facetValue {
        ...FacetValue
    }
    facetValueId
    variantProduct {
        ...Product
    }
    variantProductId

}
${BASEMODEL_FRAGMENT}
${PRODUCT_FRAGMENT}
${FACET_VALUE_FRAGMENT}
`;

export const PRODUCT_VARIANT_TO_FACET_VALUE_FRAGMENT = gql`
fragment ProductVariantToFacetValueLink on ProductVariantToFacetValueLink {
    ... ProductVariantToFacetValueLinkFields
}
${PRODUCT_VARIANT_TO_FACET_VALUE_FIELDS_FRAGMENT}
`;

export const GET_PRODUCT_VARIANT_TO_FACET_VALUE_LIST = gql`
query GetProductVariantToFacetValueLinkList($input:SearchInput) {
    getProductVariantToFacetValueLinkList(input: $input) {
        items {
            ...ProductVariantToFacetValueLink
        }
        totalItems
    }
}
${PRODUCT_VARIANT_TO_FACET_VALUE_FRAGMENT}
`;

export const GET_PRODUCT_VARIANT_TO_FACET_VALUE = gql`
query GetProductVariantToFacetValueLink($id:String!) {
    getProductVariantToFacetValueLink(id: $id) {
        ...ProductVariantToFacetValueLink
    }
}
${PRODUCT_VARIANT_TO_FACET_VALUE_FRAGMENT}
`;

export const SAVE_PRODUCT_VARIANT_TO_FACET_VALUE = gql`
mutation SaveProductVariantToFacetValueLink($input: ProductVariantToFacetValueLinkInput!) {
    saveProductVariantToFacetValueLink(input: $input){
        ...ProductVariantToFacetValueLink
    }
}
${PRODUCT_VARIANT_TO_FACET_VALUE_FRAGMENT}
`;

export const DELETE_PRODUCT_VARIANT_TO_FACET_VALUE = gql`
mutation DeleteProductVariantToFacetValueLink($id: String!) {
    deleteProductVariantToFacetValueLink(id: $id) {
        ... DeletionResponse
    }
}
${DELETION_RESPONSE_FRAGMENT}
`;

